/**
 * Holder lasteindikatoren oppe til kartet faktisk er ferdig — ikke bare nettverket.
 *
 * `isFetchingBounds` slår av i det HTTP-svaret er lest. Men da har ikke kartet tegnet
 * noe ennå: markørene bygges, klynges og settes inn etterpå, og med flere hundre
 * plasser er DET den lange delen. Målt i ekte nettleser 16.08.2026: indikatoren var
 * borte etter 0,3 s mens kartet fortsatt jobbet — «mye flimring og går tregt når det
 * virker som den laster, men ingen visuelle elementer som indikerer lasting».
 *
 * Halen er bevisst tidsbasert og ikke koblet til en render-callback: markørene tegnes
 * av Leaflet utenfor Reacts livssyklus, så det finnes ikke noe pålitelig «ferdig»-
 * signal å hekte seg på. En kort hale er ærligere enn et signal som ikke finnes.
 */

/** Hvor lenge indikatoren blir stående etter at hentingen er ferdig. */
export const LOADING_TAIL_MS = 900;

export interface LoadingTailState {
  /** Når hentingen sist gikk fra på til av. 0 = aldri. */
  ferdigVed: number;
  /** Forrige observerte hente-tilstand, for å oppdage flanken. */
  hentetSist: boolean;
}

export const initialLoadingTail = (): LoadingTailState => ({ ferdigVed: 0, hentetSist: false });

/**
 * Skal indikatoren vises nå?
 *
 * @param henter    om en henting pågår (`isFetchingBounds`)
 * @param tilstand  muterbar tilstand mellom kall
 * @param naa       nåtid i ms
 */
export const skalViseLaster = (
  henter: boolean,
  tilstand: LoadingTailState,
  naa: number,
): boolean => {
  if (henter) {
    tilstand.hentetSist = true;
    return true;
  }
  // Fallende flanke: hentingen ble nettopp ferdig, start halen.
  if (tilstand.hentetSist) {
    tilstand.hentetSist = false;
    tilstand.ferdigVed = naa;
  }
  return tilstand.ferdigVed > 0 && naa - tilstand.ferdigVed < LOADING_TAIL_MS;
};
